import { graphql } from "~/gql";

export const LIBRARY_EXCLUSIONS_QUERY = graphql(/* GraphQL */ `
  query FindLibraryExclusions($filter: LibraryExclusionWhereInput!) {
    libraryExclusions(filter: $filter) {
      ...LibraryExclusionFragment
    }
  }
`);
